import { contactsCollection, companiesCollection } from "./firebase";

// Fetch a single contact by ID
export const fetchContact = async (id) => {
  const doc = await contactsCollection.doc(id).get();
  if (doc.exists) {
    return { ...doc.data(), id: doc.id, contactID: doc.id };
  }
  throw new Error("Contact not found");
};

export const fetchContacts = async () => {
  // Fetch all contacts
  const contactSnapshot = await contactsCollection.get();
  const contacts = contactSnapshot.docs.map((doc) => ({
    ...doc.data(),
    id: doc.id,
    contactID: doc.id,
  }));

  // Fetch all companies
  const companySnapshot = await companiesCollection.get();
  const companies = companySnapshot.docs.reduce((acc, doc) => {
    acc[doc.id] = doc.data().companyName;
    return acc;
  }, {});

  return contacts.map((contact) => ({
    ...contact,
    companyName: companies[contact.companyID] || "Unknown Company",
  }));
};


export const fetchContactsByCompany = async (companyID) => {
  const snapshot = await contactsCollection
      .where("companyID", "==", companyID)
      .get();

  return snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
  }));
};